/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestPredictionValuesDto } from '../../models/harvest-prediction-values-dto';
import { HarvestSex } from '../../models/harvest-sex';

export interface GetHarvestPredictionWeightValues$Params {
  brandId?: number;
  harvestSex?: HarvestSex;
}

export function getHarvestPredictionWeightValues(http: HttpClient, rootUrl: string, params?: GetHarvestPredictionWeightValues$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestPredictionValuesDto>> {
  const rb = new RequestBuilder(rootUrl, getHarvestPredictionWeightValues.PATH, 'get');
  if (params) {
    rb.query('brandId', params.brandId, {});
    rb.query('harvestSex', params.harvestSex, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestPredictionValuesDto>;
    })
  );
}

getHarvestPredictionWeightValues.PATH = '/api/harvestPrediction/weight';
